module.exports = __webpack_public_path__ + "img/empty-network.png?7750dc0a";